import {extractFormFieldIdDetails, validateFieldMinMaxConstraints} from 'Quoting/utils/validation';
import {EntityMinMaxConfig} from 'Quoting/models/DTOs/QuoteForm';
import {A360ProductModel} from 'Quoting/models/Quoting';
import {getCoverageNameByCoverageCode, isDefined} from 'Quoting/utils/utilities';
import {getGpluValidators} from '../components/QuoteForm/Plan/PlanTemplates/GWL/validators';
import {FieldValidator, ProductValidatorConfig} from '../components/QuoteForm/Plan/products/types';

export const buildValidationResult = (
  formFieldId: string,
  isValid: boolean,
  errorMessage: string
): ReturnType<FieldValidator['validate']> => (isValid ? {formFieldId} : {formFieldId, errorMessage});

export const getValidators = (
  productModelName: A360ProductModel,
  minMaxConfig: Record<string, EntityMinMaxConfig>
): ProductValidatorConfig => {
  if (productModelName === A360ProductModel.GPLUMaster) {
    return getGpluValidators(minMaxConfig);
  }
};

export const createMinMaxValidatorsByProduct = (
  productModel: A360ProductModel,
  minMaxConfig: Record<string, EntityMinMaxConfig>
) => (formFieldId: string, fieldLabel: string, fieldValue: any) => {
  const {coverageCode, entityId, attributeId} = extractFormFieldIdDetails(formFieldId);
  const entityMinMaxConfig = minMaxConfig?.[coverageCode]?.[`${entityId}.${attributeId}`];

  const result = validateFieldMinMaxConstraints({
    value: fieldValue,
    label: fieldLabel,
    entityMinMaxConfig,
    coverageName: getCoverageNameByCoverageCode(productModel, coverageCode),
  });

  return buildValidationResult(formFieldId, !result.error, result?.helperText);
};

const SelfServeSupportedNumberOfLives = {
  MIN: 3,
  MAX: 499, // change this to 499 to support 500 Lives
} as const;

export const validateNumberOfLives = (numberOfLives: number) => {
  const isInvalid =
    isDefined(numberOfLives) &&
    (numberOfLives < SelfServeSupportedNumberOfLives.MIN || numberOfLives > SelfServeSupportedNumberOfLives.MAX);
    
  if (isInvalid) {
    return {
      error: true,
      errorMessage: `Number of lives must be between ${SelfServeSupportedNumberOfLives.MIN} and ${SelfServeSupportedNumberOfLives.MAX}`,
    };
  }
  return null;
};

export const getSelfServeSupportedMinNumberOfLives = () => SelfServeSupportedNumberOfLives.MIN;

export const getSelfServeSupportedMaxNumberOfLives = () => SelfServeSupportedNumberOfLives.MAX;